import React from 'react';
import { connect } from 'react-redux'
import { Spin, Skeleton } from 'antd';
import OptionItem from './option-item';
import InfiniteScroll from 'react-infinite-scroller';
import { LoginAction } from "@/component/login/actions";
import { getMerchantList, getMerchantToken, removeLoginData, switchMerchant } from '../utils';
import { getPlatformTokenInfo, setPlatformTokenInfo, getSessionObject, Utils } from '@/tools/utils'
import './select-merchant.less';

class SelectMerchant extends React.Component {
    constructor(props) {
        super(props);
        const loginData = getSessionObject('loginData') || {};
        const tokenInfo = getPlatformTokenInfo() || {};
        if (tokenInfo.access_token) {
            loginData.params = {
                ...loginData.params,
                token: tokenInfo.access_token
            }
            loginData.loginType = 'token';
        }
        this.state = {
            containerHeight: '390px',
            hasMore: false,
            total: 0,
            current: 1,
            pageSize: 20,
            merchantList: [],
            loginData: loginData,
        }
    }

    componentDidMount() {
        this.loadData();
    }

    // 获取商户列表
    loadData = async (page = 1) => {
        const { loginData } = this.state;
        const params = {
            ...loginData.params,
            ...{
                page,
                limit: this.state.pageSize
            }
        };
        getMerchantList(params, loginData.loginType)
            .then(res => {
                this.setState({
                    merchantList: [...this.state.merchantList, ...res.data.rows],
                    total: res.data.total,
                    current: page,
                    hasMore: res.data.total > this.state.pageSize * page
                });
            })
    }
    loginSuccess = (data) => {
        const _token = data.token_type + data.access_token;
        let { access_token, token_type, refresh_token, expires_in } = data;
        const _tokenInfo = {
            access_token,
            token_type,
            refresh_token,
            expires_in,
            loginWay: 'newLogin',
            nowTime: Date.parse(new Date()) / 1000
        };
        setPlatformTokenInfo(JSON.stringify(_tokenInfo));
        removeLoginData();
        this.props.setToken(_token);
    };

    handleClickOption = async ({ orgId }) => {
        const { loginData } = this.state;
        const params = {
            orgId,
            ...loginData.params
        };
        localStorage.setItem('orgId', orgId);
        // 替换token, 删除loginData
        // const tokenRes = await getMerchantToken(params, loginData.loginType);
        if (loginData.loginType === 'pwd') {
            const tokenRes = await getMerchantToken(params, loginData.loginType);
            this.loginSuccess(tokenRes.data);
            if (this.props.onSelect) this.props.onSelect();
        } else {
            const tokenRes = await switchMerchant(params).then((res) => {
                this.loginSuccess(res);
                if (this.props.onSelect) this.props.onSelect();
            });
        }
    };
    render() {
        const { height } = this.props;
        const { merchantList, hasMore } = this.state;
        return (
            <div
                className="merchant-list"
                style={{
                    height: height || this.state.containerHeight,
                }}
            >
                <InfiniteScroll
                    initialLoad={false}
                    pageStart={1}
                    loadMore={this.loadData}
                    hasMore={hasMore}
                    loader={
                        merchantList.length > 0 && <div className="loader" key={0}><Spin /></div>
                    }
                    useWindow={false}
                >
                    {
                        merchantList.length > 0 ?
                            merchantList.map(item => {
                                return (
                                    <OptionItem
                                        {...this.props}
                                        key={item.orgId}
                                        data={item}
                                        active={item.orgId === Utils.getUserData().orgId}
                                        title={item.name}
                                        desc={item.orgCname}
                                        disable={item.deactivated === 1}
                                        deactivated={item.userDeactivated === 1}
                                        showDisableTag
                                        onClick={this.handleClickOption}
                                    />
                                )
                            })
                            :
                            <Skeleton />
                    }
                </InfiniteScroll>
            </div>
        );
    }
};

export default connect(null, { ...LoginAction })(SelectMerchant);
